import { defineComponent as b, mergeModels as g, useModel as y, createElementBlock as o, openBlock as l, mergeProps as u, unref as a, createElementVNode as n, createCommentVNode as m, Fragment as v, normalizeClass as t, createVNode as h, toDisplayString as w } from "vue";
import s from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Switch/switch.js";
import { CheckIcon as p } from "../packages/icons/dist/esm/icons/check-icon.js";
import { isDefined as I } from "../node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
import { useOUIAProps as B } from "../helpers/ouia.js";
const V = ["name", "disabled", "checked"], C = ["name", "value", "disabled"], N = /* @__PURE__ */ b({
  name: "PfSwitch",
  inheritAttrs: !1,
  __name: "Switch",
  props: /* @__PURE__ */ g({
    checkIcon: { type: Boolean },
    reversed: { type: Boolean },
    label: {},
    labelAttrs: {},
    offValue: {},
    name: {},
    disabled: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    checked: { type: Boolean, default: !1 },
    checkedModifiers: {}
  }),
  emits: ["update:checked"],
  setup(r) {
    const d = r, f = B({ id: d.ouiaId, safe: d.ouiaSafe }), i = y(r, "checked");
    return (e, c) => (l(), o("label", u({ ...a(f), ...e.labelAttrs }, {
      class: [a(s).switch, e.$attrs.class, {
        [a(s).modifiers.reverse]: e.reversed
      }]
    }), [
      n("input", u(e.$attrs, {
        name: e.name,
        disabled: e.disabled,
        class: a(s).switchInput,
        type: "checkbox",
        role: "switch",
        checked: i.value,
        onChange: c[0] || (c[0] = (k) => i.value = k.currentTarget.checked)
      }), null, 16, V),
      e.name && a(I)(e.offValue) && !i.value ? (l(), o("input", {
        key: 0,
        name: e.name,
        type: "hidden",
        value: e.offValue,
        disabled: e.disabled
      }, null, 8, C)) : m("", !0),
      e.label ? (l(), o(v, { key: 1 }, [
        n("span", {
          class: t(a(s).switchToggle)
        }, [
          e.checkIcon ? (l(), o("div", {
            key: 0,
            class: t(a(s).switchToggleIcon),
            "aria-hidden": "true"
          }, [
            h(a(p))
          ], 2)) : m("", !0)
        ], 2),
        n("span", {
          class: t(a(s).switchLabel),
          "aria-hidden": "true"
        }, w(e.label), 3)
      ], 64)) : (l(), o("span", {
        key: 2,
        class: t(a(s).switchToggle)
      }, [
        n("div", {
          class: t(a(s).switchToggleIcon),
          "aria-hidden": "true"
        }, [
          h(a(p))
        ], 2)
      ], 2))
    ], 16));
  }
});
export {
  N as default
};
